import { render, staticRenderFns } from "./SectionTransition.vue?vue&type=template&id=49164123&"
import script from "./SectionTransition.vue?vue&type=script&lang=js&"
export * from "./SectionTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports